import { Route, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private _authService: AuthService, private router: Router) {}
    private isTokenCheckInProgress = false;

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Clone the request object
        let newReq = this.addAuthorizationHeader(req);

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {
                return this.handleHttpError(error, req, next);
            })
        );
    }

    private addAuthorizationHeader(req: HttpRequest<any>): HttpRequest<any> {
        if (req.url.includes('verification.coduluz')) {
            return req;
        }
        if (
            this._authService.accessToken &&
            !AuthUtils.isTokenExpired(this._authService.accessToken)
        ) {
            return req.clone({
                withCredentials: true,
                headers: req.headers.set(
                    'Authorization',
                    'Bearer ' + this._authService.accessToken
                ),
            });
        }
        return req;
    }

    private handleHttpError(
        error: any,
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const sessionJwt = sessionStorage.getItem('jwt');
        if (sessionJwt && !this.isTokenCheckInProgress) {
            const isExpired = AuthUtils.isTokenExpired(sessionJwt);
            if (isExpired) {
                this.isTokenCheckInProgress = true;
                return this._authService.refreshJwtToken(sessionJwt).pipe(
                    switchMap((newToken) => {
                        sessionStorage.removeItem('jwt');
                        sessionStorage.setItem(
                            'jwt',
                            AuthUtils.getCookieFromStorage('jwt')
                        );
                        this.isTokenCheckInProgress = false;

                        const newReq = this.addAuthorizationHeader(req);

                        return next.handle(newReq).pipe(
                            catchError((error) => {
                                if (
                                    error instanceof HttpErrorResponse &&
                                    error.status === 401
                                ) {
                                    this.router.navigate(['/']);
                                }
                                return throwError(error);
                            })
                        );
                    })
                );
            }
        }

        if (error instanceof HttpErrorResponse && error.status === 401) {
            this.router.navigate(['/']);
        }

        return throwError(error);
    }
}
